import { FC, useState, useEffect } from "react";
import { Modal } from "antd";

import { Button } from "elements";

import ArootahLogo from "assets/images/header_logo_modern_2.svg";

// @ts-ignore
import { ReactComponent as CloseIcon } from "assets/images/x.svg";

import {
  Wrapper,
  Logo,
  Title,
  Text,
  CloseButton,
  Footer,
  MistakeText,
  UndoLink
} from "./styled";

interface CompleteActionItemModalProps {
  open: any;
  setOpen: (value: any) => void;
  onComplete: (value: any) => void;
  onUndo?: (completedGoal: any) => void;
}

const CompleteActionItemModal: FC<CompleteActionItemModalProps> = ({ open, setOpen, onComplete, onUndo }) => {
  const [countdown, setCountdown] = useState(15);

  useEffect(() => {
    if (open) {
      setCountdown(15);
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            setOpen(null);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [open, setOpen]);

  const handleCancel = () => {
    setOpen(null);
  };

  const handleClick = () => {
    onComplete(open);
  };

  const handleUndo = () => {
    // Call the undo function with the completed goal data
    if (onUndo && open?.completedGoal) {
      onUndo(open.completedGoal);
    }
    setOpen(null);
  };

  return (
    <Modal open={!!open} footer={false} centered width={750} closable={false}>
      <Wrapper>
        <CloseButton onClick={handleCancel}>
          Close
          <CloseIcon />
        </CloseButton>

        <Logo src={ArootahLogo} width="196" height="36" alt="Arootah" />

        <Title>Goal Completed</Title>
        <Text>You've successfully completed your goal</Text>

        <Button size="medium" onClick={handleClick}>Continue</Button>

        <Footer>
          <MistakeText>Made A Mistake? </MistakeText>
          <UndoLink onClick={handleUndo}>
            Click Here To Undo ({countdown}s Left)
          </UndoLink>
        </Footer>
      </Wrapper>
    </Modal>
  );
};

export default CompleteActionItemModal;
